<template>
    <div class="ggmf-card recent-projects-card">
        <div class="ggmf-card__header">
            <h4 class="ggmf-card__title">
                <i class="ri-folder-chart-line"></i>
                Projetos Recentes
            </h4>
            <router-link to="/projects" class="ggmf-card__link">Ver todos</router-link>
        </div>
        <div class="ggmf-card__body">
            <!-- Loading -->
            <div v-if="loading">
                <div v-for="i in 3" :key="i" class="project-item-skeleton"></div>
            </div>

            <!-- Sem projetos -->
            <div v-else-if="!projects.length" class="empty-state">
                <i class="ri-folder-line"></i>
                <p>Nenhum projeto registado</p>
            </div>

            <!-- Lista -->
            <ul v-else class="projects-list">
                <li v-for="project in projects" :key="project.id" class="project-item">
                    <div class="project-item__cover">
                        <template v-if="project.coverImageUrl">
                            <video v-if="isVideo(project.coverImageUrl)" :src="project.coverImageUrl"
                                class="project-item__media"></video>
                            <img v-else :src="project.coverImageUrl" :alt="project.title_pt"
                                class="project-item__media">
                        </template>
                        <div v-else class="project-item__cover-placeholder">
                            <i class="ri-folder-line"></i>
                        </div>
                    </div>
                    <div class="project-item__info">
                        <h5 class="project-item__title">{{ project.title_pt }}</h5>
                        <span :class="['project-item__category', `cat-${project.category.name_pt.toLowerCase()}`]">
                            {{ categoryLabel(project.category.name_pt) }}
                        </span>
                    </div>
                    <p class="project-item__date">{{ formatDate(project.createdAt) }}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
const CATEGORY_LABELS = {
    EDUCACAO: 'Educação',
    SAUDE: 'Saúde',
    CULTURA: 'Cultura',
    SOCIAL: 'Social',
};

export default {
    name: 'RecentProjects',
    props: {
        projects: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        isVideo(url) {
            if (!url) return false;
            const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov'];
            return videoExtensions.some(ext => url.toLowerCase().includes(ext));
        },
        categoryLabel(cat) {
            return CATEGORY_LABELS[cat] || cat;
        },
        formatDate(dateStr) {
            return new Date(dateStr).toLocaleDateString('pt-PT', {
                day: '2-digit', month: 'short', year: 'numeric',
            });
        },
    },
};
</script>

<style lang="scss">
.recent-projects-card {
    margin-bottom: 24px;
}

.projects-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.project-item {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 12px 0;
    border-bottom: 1px solid #F3F4F6;

    &:last-child {
        border-bottom: none;
    }

    &__cover {
        width: 52px;
        height: 52px;
        border-radius: 12px;
        overflow: hidden;
        flex-shrink: 0;
        background: #F3F4F6;

        .project-item__media {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__cover-placeholder {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #5C31D6;
        font-size: 22px;
        background: #F0EBFF;
    }

    &__info {
        flex: 1;
        min-width: 0;
    }

    &__title {
        font-size: 13px;
        font-weight: 600;
        margin: 0 0 5px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__category {
        font-size: 10px;
        font-weight: 700;
        padding: 3px 10px;
        border-radius: 20px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    &__date {
        font-size: 11px;
        color: #9ca3af;
        margin: 0;
        white-space: nowrap;
    }
}

.cat-educacao {
    background: #EBF1FF;
    color: #1765FD;
}

.cat-saude {
    background: #EDFBF3;
    color: #4FCB8D;
}

.cat-cultura {
    background: #FFF3EB;
    color: #FF6B35;
}

.cat-social {
    background: #F0EBFF;
    color: #5C31D6;
}

.project-item-skeleton {
    height: 64px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;
    border-radius: 12px;
    margin-bottom: 10px;
}
</style>
